import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../components/table";
import { saveTransactionsData } from "../../store/slice/transactionsSlice";
import { fetchTransactions } from "../../api/endpoint";
import Pagination from "../../components/pagination";
import { convertUTCToLocalString } from "../../utils/format";
import axios from "axios";

const headings = [
  { name: "Name", fieldName: "name", isSortable: false, sortKey: "none" },
  { name: "Purchase", fieldName: "purchase", isSortable: false, sortKey: "none" },
  { name: "Transaction Date", fieldName: "transaction", isSortable: false, sortKey: "none" },
];

const Transactions = () => {
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Use API-provided pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    getTransactions();
  }, [currentPage]);

  const getTransactions = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchTransactions, {
        headers: { Authorization: `Bearer ${auth}` },
        params: { page: currentPage, size: pageSize },
      });

      const { content, totalPages } = response?.data;

      const rows = content?.map((transaction) => ({
        name: transaction?.name,
        purchase: transaction?.amount,
        transaction: convertUTCToLocalString(transaction?.transactionDate),
      }));

      setTableData(rows);
      setTotalPages(totalPages);
      dispatch(saveTransactionsData(content));
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="card rounded-4">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h5 className="mb-3">Transactions</h5>
            <Link to="/transactions" style={{ textDecoration: "none" }}>
              See All
            </Link>
          </div>
          <Table
            headings={headings}
            data={tableData}
            enablePagination={false}
            enableSearch={false}
            card={false}
          />
        </div>
        {/* {loading && <Loader />} */}
      </div>

      {totalPages > 1 && (
        <div className="d-flex justify-content-end mt-2">
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}
    </div>
  );
};

export default Transactions;
